import BasePropertyView from 'BasePropertyView.js';
import imageImportLabelsTemplate from 'properties/main/image-import-button-labels.ejs';

class MainImageButtonLabelsView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.tagName = 'div';
        this.id = opts.el;
        this.template=imageImportLabelsTemplate;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainImageButtonLabelsView;
